import * as types from './mutation-types';

const mutations = {
  [types.CHANGE_SCREEN_WIDTH](state, val) {
    state.screenWidth = val;
  },
  [types.GET_MAIN_NAME](state, val) {
    state.name = val;
  },
  LOCALE(state,payload){
    state.locale = payload
  }
};

export default mutations;
